<template>
  <v-container fluid>
    <el-overlay-loading :loading="pageloading" />
    <!-- title  -->
    <h1 class="mb-1">{{ $t(getTitle) }}</h1>
    <!-- form  -->
    <v-card outlined class="mb-4">
      <form @keydown.enter.prevent="submit()">
        <v-card-text class="mt-5">
          <v-row class="mb-0 pb-0">
            <v-col cols="12" md="12">
              <el-text-field
                label="Panaikinimo / atsisakymo požymis (LT)"
                v-model="formData.title_lt"
                :maxlength="200"
                :disabled="modeReadonly"
                required
              />
            </v-col>
            <v-col cols="12" md="12">
              <el-text-field
                label="Panaikinimo / atsisakymo požymis (EN)"
                v-model="formData.title_en"
                :maxlength="200"
                :disabled="modeReadonly"
                required
              />
            </v-col>
            <v-col cols="12" md="12">
              <el-textarea
                autocomplete="off"
                name="Aprašymas"
                label="Aprašymas"
                type="text"
                :disabled="modeReadonly"
                v-model="formData.description"
                :maxlength="200"
              />
            </v-col>

            <v-col cols="12" md="3">
              <el-text-field
                label="Kodas"
                required
                :disabled="modeReadonly"
                v-model="formData.code"
                :maxlength="20"
              />
            </v-col>

            <v-col cols="12" md="3">
              <el-date-picker
                label="Galioja nuo"
                required
                :disabled="modeReadonly"
                v-model="formData.valid_from"
              />
            </v-col>
            <v-col cols="12" md="3">
              <el-date-picker
                label="Galioja iki"
                :afterDate="formData.valid_from"
                :disabled="modeReadonly"
                v-model="formData.valid_to"
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-row no-gutters>
            <v-spacer></v-spacer>
            <el-button
              class="mr-1"
              color="secondary"
              icon="atšaukti"
              title="Atšaukti"
              @click.native.stop="back()"
              :loading="loading"
            />
            <el-button
              v-if="!modeReadonly"
              title="Išsaugoti"
              :loading="loading"
              @click.native="saveData()"
              color="primary"
              icon="išsaugoti"
            />
          </v-row>
        </v-card-actions>
      </form>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import userRole from '@/mixins/userRole'

export default {
  name: 'AdminCancelReasonForm',

  mixins: [userRole],
  $_veeValidate: {
    validator: 'new',
  },
  data() {
    return {
      pageloading: false,
      loading: false,
      formData: {},
    }
  },
  computed: {
    modeReadonly() {
      return false
    },

    getId() {
      return this.$route.params.id || null
    },

    getTitle() {
      if (this.getId) {
        return this.$t(`Redaguoti panaikinimo / atsisakymo požymį`)
      } else {
        return this.$t(`Naujas panaikinimo / atsisakymo požymis`)
      }
    },
  },
  beforeDestroy() {},
  created() {
    if (this.getId) {
      this.getData()
    }
  },
  methods: {
    back() {
      this.$router.push({ name: 'classifierCancelReasons' })
    },

    getData() {
      this.pageloading = true

      this.$axios
        .get(`cancel-reasons/${this.getId}`)
        .then((res) => {
          this.formData = res.data.cancelReason
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
        .finally(() => {
          this.pageloading = false
        })
    },

    saveData() {
      this.$validator.validateAll().then((res) => {
        if (res) {
          this.loading = true
          let formData = this.formData
          let url = `cancel-reasons`
          this.getId && (formData.id = this.getId)
          this.$axios
            .post(url, formData)
            .then((res) => {
              this.$root.$emit('DATA_OK_CODE', '000110')
              this.back()
            })
            .catch((err) => {
              this.$root.$emit('DATA_ERROR', err)
            })
            .finally(() => {
              this.loading = false
            })
        } else {
          this.$root.$emit('FORMAT_ERROR')
        }
      })
    },
  },
}
</script>
<style lang="scss" scoped></style>
